// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__L8Tn4","col":"styles_col__19vaK"};